var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emoji-component"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"item"},[_c('div',{staticClass:"icon",on:{"click":function($event){return _vm.select(item)}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }